import {
  Checkbox,
  DateInput,
  Switch,
  TextArea,
  TextInput,
  Typography,
} from "@codat/orchard-ui";
import { ProductSetting } from "api/schema/productsSchema";
import React from "react";
import { UseFormGetValues, UseFormRegister } from "react-hook-form";

import styles from "./ProductSettings.module.scss";

export type FormData = Record<
  string,
  string | boolean | Date | null | undefined
>;

export type DynamicSettingsProps = {
  setting: ProductSetting;
  register: UseFormRegister<FormData>;
  values: FormData;
  updateValues: (key: string, value: string | boolean | Date) => void;
  getValues: UseFormGetValues<FormData>;
};

export const DynamicSetting = ({
  setting,
  register,
  values,
  updateValues,
  getValues,
}: DynamicSettingsProps) => {
  switch (setting.dataType) {
    case "TextInput":
      return (
        <TextInput
          label={setting.name}
          description={setting.description}
          labelClassName={styles.label}
          data-testid={`${setting.key}-input`}
          {...register(setting.key)}
        />
      );
    case "Checkbox":
      return (
        <div className={styles.input}>
          <div>
            <Typography as="h4" variant="heading_sm" className={styles.label}>
              {setting.name}
            </Typography>
            <Typography as="p" variant="p">
              {setting.description}
            </Typography>
          </div>
          <Checkbox
            data-testid={`${setting.key}-input`}
            checked={!!values[setting.key]}
            {...register(setting.key)}
            onChange={(e) => updateValues(setting.key, e.target.checked)}
          />
        </div>
      );
    case "DateInput":
      return (
        <div className={styles.dateContainer}>
          <DateInput
            data-testid={`${setting.key}-input`}
            label={setting.name}
            labelClassName={styles.label}
            value={
              getValues(setting.key)
                ? new Date(getValues(setting.key) as string)
                : new Date()
            }
            onValueChange={(date) => updateValues(setting.key, date)}
            {...register(setting.key)}
          />
          <Typography as="p" variant="p">
            {setting.description}
          </Typography>
        </div>
      );
    case "Switch":
      return (
        <div className={styles.input}>
          <div>
            <Typography as="h3" variant="heading_sm" className={styles.label}>
              {setting.name}
            </Typography>
            <Typography as="p" variant="p">
              {setting.description}
            </Typography>
          </div>
          <Switch
            data-testid={`${setting.key}-input`}
            isChecked={!!values[setting.key]}
            onClick={() => updateValues(setting.key, !getValues(setting.key))}
          />
        </div>
      );
    case "TextArea":
      return (
        <TextArea
          data-testid={`${setting.key}-input`}
          label={setting.name}
          labelClassName={styles.label}
          description={setting.description}
          {...register(setting.key)}
        />
      );
    case "MaskedTextInput":
      return null; // Not implemented yet
  }
};
